var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.detailInfo != null
    ? _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading.fullscreen",
              value: _vm.loading,
              expression: "loading",
              modifiers: { fullscreen: true }
            }
          ],
          staticClass: "full_layout detail",
          attrs: { id: "detail" }
        },
        [
          _c("div", { staticClass: "breadcrumbANDsort" }, [
            _c(
              "div",
              { staticClass: "breadcrumb" },
              [
                _c("router-link", { attrs: { to: { path: "/" } } }, [
                  _vm._v(_vm._s(_vm.$t("Home")))
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.detailInfo.Title))])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "productsDetail space_between" },
            [
              _c("card-swiper", {
                attrs: {
                  imglist: _vm.imageList,
                  releaseType: _vm.detailInfo.ReleaseType,
                  presale: _vm.detailInfo.Presale
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "detailText" }, [
                _c("h2", { staticClass: "h2 pointTitle" }, [
                  _vm._v(_vm._s(_vm.detailInfo.Title))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "detailInfo" }, [
                  _c("div", { staticClass: "detailPrice space_between" }, [
                    _c("div", { attrs: { id: "pointsPrice" } }, [
                      _c("span", { staticClass: "points" }, [
                        _vm._v(
                          _vm._s(_vm.detailInfo.PointsScore) +
                            " " +
                            _vm._s(_vm.$t("Points")) +
                            "  "
                        )
                      ]),
                      _vm.detailInfo.Price > 0
                        ? _c("span", { staticClass: "pointPrice" }, [
                            _vm._v(
                              "+￥ " +
                                _vm._s(_vm.detailInfo.Price.toLocaleString())
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    (_vm.detailInfo.QuantitySold <= 0 &&
                      _vm.detailInfo.ReleaseType != 1) ||
                    _vm.detailInfo.Status < 1
                      ? _c("div", { staticClass: "outOfStock" }, [
                          _vm._v(
                            _vm._s(
                              _vm.detailInfo.Status <= -2
                                ? _vm.$t("Unavailable")
                                : _vm.$t("OutofStock")
                            )
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.detailInfo.QuantitySold > 0 && _vm.detailInfo.Status > 0
                    ? _c(
                        "div",
                        { staticClass: "detailBtn space_between" },
                        [
                          _c("el-input-number", {
                            attrs: {
                              min: 1,
                              max:
                                _vm.detailInfo.QuantitySold >= 5
                                  ? 5
                                  : _vm.detailInfo.QuantitySold
                            },
                            on: { change: _vm.quantityChange },
                            model: {
                              value: _vm.quantitySold,
                              callback: function($$v) {
                                _vm.quantitySold = $$v
                              },
                              expression: "quantitySold"
                            }
                          }),
                          _vm._v(" "),
                          _vm.userInfo != null
                            ? _c(
                                "div",
                                { staticClass: "detailBall" },
                                [
                                  _vm.detailInfo.ReleaseType != 1 &&
                                  _vm.detailInfo.Presale != 1
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function($event) {
                                              return _vm.goToPay(_vm.detailInfo)
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("RedeemNow")))]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.userInfo == null
                            ? _c(
                                "div",
                                { staticClass: "detailBall" },
                                [
                                  _vm.detailInfo.ReleaseType != 1 &&
                                  _vm.detailInfo.Presale != 1
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function($event) {
                                              return _vm.tologin()
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("RedeemNow")))]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pack" }, [
                  _c("div", [_vm._v(_vm._s(_vm.$t("PackageDetails")))]),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "explain_P",
                    domProps: { innerHTML: _vm._s(_vm.detailInfo.Explain) }
                  })
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "describe" },
            [
              _c("el-divider", { attrs: { "content-position": "center" } }, [
                _vm._v(_vm._s(_vm.$t("ProductDescription")))
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "describeBox",
                domProps: { innerHTML: _vm._s(_vm.detailInfo.Detail) }
              })
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e4780b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e4780b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/point/item.vue
// module id = null
// module chunks = 